<template>
  <div class="LKBannersHeader">
    <transition name="fade-slow" mode="out-in">
      <div v-if="navigation" class="LKBannersHeader__navigation">
        <v-btn icon dark class="LKBannersHeader__btn" @click="$emit('prev')">
          <v-icon v-text="'mdi-chevron-left'" />
        </v-btn>

        <div v-if="dots" class="LKBannersHeader__counter">
          <span
            class="LKBannersHeader__counter-current"
            v-text="current"
          />
          /
          <span
            class="LKBannersHeader__counter-count"
            v-text="count"
          />
        </div>

        <div v-else class="LKBannersHeader__counter">
          <template v-for="item in count">
            <div
              :key="item"
              :class="{ 'is-active': item === current }"
              class="LKBannersHeader__counter-circle"
            />
          </template>
        </div>

        <v-btn icon dark class="LKBannersHeader__btn" @click="$emit('next')">
          <v-icon v-text="'mdi-chevron-right'" />
        </v-btn>
      </div>
    </transition>

    <LKRoadmapsFeedToggleLine
      :active="active"
      :label="label"
      :new-count="newCount"
      reverse
      class="LKBannersHeader__line"
      @click.native="$emit('update:active', !active)"
    />
  </div>
</template>

<script>
import LKRoadmapsFeedToggleLine from '@/views/LKRoadmapsFeed/components/ui/LKRoadmapsFeedToggleLine.vue'


export default {
  name: 'LKBannersHeader',
  components: {
    LKRoadmapsFeedToggleLine,
  },
  props: {
    active: {
      type: Boolean,
    },
    current: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    newCount: Number,
    dots: Boolean,
    navigation: Boolean,
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    onChangeCurrent(direction = 1) {
      const value = this.current + direction
      this.$emit('update:current', value)
    },
  },
}
</script>

<style lang="scss" src="@/assets/scss/transitions/transition-fade.scss"></style>

<style lang="scss">
$height: 32px;

.LKBannersHeader {
  display: flex;
  align-items: center;
  height: $height;

  &__navigation {
    display: flex;
    align-items: center;
    margin-right: 16px;
  }

  &__btn {
    width: $height !important;
    height: $height !important;
    color: $webflow-color-white;
    background-color: $webflow-color-blue-dark;
  }

  &__counter {
    display: flex;
    align-items: center;
    margin: 0 16px;
    color: $webflow-color-blue-hover;
    white-space: nowrap;

    &-circle {
      width: 6px;
      height: 6px;
      margin: 5px;
      background-color: currentColor;
      border-radius: 50%;

      &.is-active {
        color: $webflow-color-blue-dark;
      }
    }

    &-current,
    &-count {
      min-width: 20px;
      text-align: center;
    }

    &-current {
      font-weight: bold;
      color: $webflow-color-blue-dark;
    }

    &-count {
      color: $webflow-color-blue-dark;
      opacity: 0.5;
    }
  }

  &__line {
    margin-bottom: 0 !important;
    opacity: 1 !important;

    .text-md {
      font-weight: bold !important;
      color: $webflow-color-blue-dark !important;
    }
  }
}
</style>
